module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Angi Morgan\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_c('I', [_vm._v("Intrigues where danger and honor collide with love. ")]), _vm._v("Using actual Texas settings and realistic characters, this award-winning 11th generation Texan creates stories with characters who put everything on the line. Angi lives in Texas with her husband and 'four-legged' kids. Find her at AngiMorgan.com")], 1)], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/Qhu4Ym/tc-custom/9781460378724.jpg?1703654023244",
      "alt": "This image is the cover for the book Ranger, West Texas Watchmen Series"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Ranger, West Texas Watchmen Series\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("A Texas Ranger must protect a single mom with a target on her back in this breathtaking romantic thriller from the author of "), _c('i', [_vm._v("The Cattleman")]), _vm._v(" and "), _c('i', [_vm._v("The Sheriff")]), _vm._v(".")]), _c('br'), _c('br'), _vm._v("Texas Ranger Mitch Striker’s uncomplicated bachelor lifestyle suits him just fine: catch the bad guys and move on. But there’s nothing straightforward about struggling single mom Brandie Ryland or her adorable four-year-old son, Toby. The beautiful redhead is the prime suspect in Mitch’s undercover investigation. But when a hostage standoff leaves Brandie’s family vulnerable and uncovers a roomful of contraband and drugs, Mitch second-guesses her involvement in the crime . . . and his ability to keep his emotional distance. With the danger growing and the clock ticking, Mitch must save Brandie, catch the perps and handle the daddy heartstrings Toby keeps tugging on. Then he’ll have to face the secrets he’s sure Brandie’s keeping—before they become his undoing.\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0